<template>
  <img
    :src="image"
    :alt="alt"/>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    image() {
      return `${process.env.VUE_APP_ATTACHMENT_BASE_URL}/attach/${this.id}`;
    },
  },
};
</script>
